// extracted by mini-css-extract-plugin
export var defaultWrapper = "_l5-3";
export var downloadButton = "_l5-4";
export var fileContainer = "_l5-9 _l5-7";
export var fileContainerBase = "_l5-7";
export var fileContainerFixedHeight = "_l5-8 _l5-7";
export var fileInfo = "_l5-5";
export var fileInfoWidthRestricted = "_l5-6";
export var fileType = "_l5-1";
export var fileTypeName = "_l5-2";
export var image = "_l5-0";
export var link = "_l5-b";
export var overflowEllipsis = "_l5-a";